import { Component } from '@angular/core'
import { ButtonModule } from "primeng/button"
import { DividerModule } from "primeng/divider"

/**
 * Component displaying the public cookie policy
 *
 * @author Dan Bennett
 */
@Component({
    selector: 'app-cookie-policy',
    imports: [
        ButtonModule,
        DividerModule,
    ],
    templateUrl: './cookie-policy.component.html',
    styleUrl: './cookie-policy.component.sass'
})
export class CookiePolicyComponent {

}
